import styled from 'styled-components'

import { COLOURS } from 'resources'
import { BREAKPOINTS } from 'resources/constants'
import { ReactComponent as ReklaimLogo } from 'resources/images/brand/reklaim-logo.svg'

import SocialLinks from 'components/SocialLinks'

export const FooterContainer = styled.div`
  height: 100%;
  background-color: ${COLOURS.black};
  padding: 14px 25px;
  display: grid;
  grid-gap: 0;
  grid-template-areas:
    'social-links'
    'links'
    'copyright';

  @media (min-width: ${BREAKPOINTS.md}) {
    grid-gap: 20px;
    grid-template-areas: 'copyright links social-links';
    grid-template-columns: auto 1fr auto;
  }
`

export const ReklaimLogoYellow = styled(ReklaimLogo)`
  width: 13px;
  height: 13px;
  margin-right: 8px;

  @media (min-width: ${BREAKPOINTS.md}) {
    width: 29px;
    height: 29px;
  }

  path {
    fill: ${COLOURS.primaryYellow};
  }
`

export const CopyrightContainer = styled.div`
  grid-area: copyright;
  display: flex;

  justify-content: center;
  align-items: center;
  text-align: center;
`

export const CopyrightText = styled.span`
  color: ${COLOURS.white};
  font-size: 10px;
  display: inline-block;
  @media (min-width: ${BREAKPOINTS.md}) {
    font-size: 16px;
  }
`
export const LinkContainer = styled.div`
  grid-area: links;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const TextLink = styled.a`
  color: ${COLOURS.white};
  font-size: 12px;
  display: flex;
  align-items: center;
  padding: 8px 10px;
  transition: font-weight 0.2s;
  text-align: center;

  :hover {
    text-decoration: none;
    color: ${COLOURS.white};
    font-weight: bold;
  }

  @media (min-width: ${BREAKPOINTS.md}) {
    padding: 10px 12px;
    font-size: 16px;
  }
`

export const TextLinkSplit = styled.div`
  color: ${COLOURS.white};
  font-size: 12px;
  cursor: default;

  @media (min-width: ${BREAKPOINTS.md}) {
    font-size: 16px;
  }
`

export const FooterSocialLinks = styled(SocialLinks)`
  grid-area: social-links;
  display: flex;
  justify-content: center;
  align-items: center;
`
